export class User {
    userId: string
    userName: string
    userURL?: string
    phone?: string
    email?: string
    allowTenant?: boolean
    allowAnonymous?: boolean
    planCompanies: number
    pixKey?: string
    pixType?: string
}
